import { useEffect } from "react";
import { identify, setConsent } from "@/shared/analytics";
import type { UserAccountData } from "@/shared/types/account";

export function useAnalyticsIdentity(userData: UserAccountData | null) {
  useEffect(() => {
    if (!userData) return;

    identify(userData.id);
    if (userData.analytics_consent !== null) {
      setConsent(userData.analytics_consent);
    }
  }, [userData]);
}
